import React, { useEffect, useRef, useState } from 'react';

export default function TrustClose() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    // Guard against browsers that do not support IntersectionObserver
    if (typeof IntersectionObserver === 'undefined') {
      // Fallback: make the section visible immediately
      setIsVisible(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting) setIsVisible(true);
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    // Cleanup observer on unmount
    return () => {
      if (observer) observer.disconnect();
    };
  }, []);

  return (
    <section
      id="contact"
      ref={sectionRef}
      className="relative py-36 overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/1c49b3766e58bcbdef734065c7ec816a.jpg"
          alt="Abstract background"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-[#0E1A2B]/85"></div>
      </div>

      {/* Floating orbs */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/3 left-1/4 w-48 h-48 bg-[#2FB8AC]/8 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 right-1/3 w-64 h-64 bg-[#4A6FA5]/6 rounded-full blur-3xl"></div>
      </div>

      <div
        className={`relative z-10 max-w-3xl mx-auto px-6 text-center transition-all duration-700 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        <div className="flex justify-center mb-8">
          <div className="w-16 h-16 rounded-full bg-white/10 backdrop-blur-sm flex items-center justify-center border border-white/20">
            <i className="ri-shield-star-line text-2xl text-[#2FB8AC]"></i>
          </div>
        </div>
        <h2
          className="text-4xl md:text-5xl font-semibold text-white mb-6"
          style={{ fontFamily: 'Inter, sans-serif', letterSpacing: '-0.03em' }}
        >
          Operational Intelligence.<br />
          Deployed Responsibly.
        </h2>
        <p className="text-lg text-gray-300 mb-10 max-w-2xl mx-auto leading-relaxed">
          Aivina delivers AI systems built for industries where trust,
          compliance, and performance are non‑negotiable.
        </p>
        <a
          href="mailto:contact@aivina.ai"
          className="inline-block bg-[#2FB8AC] text-white px-10 py-4 rounded-md text-base font-medium hover:bg-[#28a89d] transition-all hover:shadow-lg hover:shadow-[#2FB8AC]/25 whitespace-nowrap cursor-pointer"
        >
          Book a Consultation
        </a>
      </div>

      {/* Footer */}
      <div className="relative z-10 border-t border-white/10 py-8">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <p className="text-white/60 text-sm">
            © 2024 Aivina. All rights reserved.
          </p>
        </div>
      </div>
    </section>
  );
}
